import { Flow_0_0_2 } from '@flexus/core';

export const SIL_21: Flow_0_0_2 = {
	id: '21',
	name: 'job_awarded',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to allocate team leader'
		}
	},
	startNode: '',
	nodes: {}
};
